import { useTranslation } from "react-i18next";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { INBOUND_PHONE_NUMBERS } from "../constants/phoneNumbers";
import "./PhoneNumbersList.css";

function PhoneNumbersList() {
  const { t } = useTranslation();

  return (
    <div className="phone-numbers-section">
      <Box variant="awsui-key-label">{t("scenarios.call.phone_numbers_to_call")}</Box>
      <Box variant="small" color="text-body-secondary" margin={{ bottom: "xs" }}>{t("scenarios.call.inbound_monitoring_instructions")}</Box>
      <SpaceBetween size="xs">
        {INBOUND_PHONE_NUMBERS.map((phone) => (
          <div key={phone.e164} className="phone-number-row">
            <span className="phone-flag" role="img" aria-label={phone.country}>{phone.flag}</span>
            <span className="phone-display">{phone.display}</span>
          </div>
        ))}
      </SpaceBetween>
    </div>
  );
}

export default PhoneNumbersList;
